export const PROFILES = {
  ADMIN: 1,
  READ: 2,
};

export const ACCESS = {
  APP: "app",
  CAMPAIGNS: "campaigns",
  RECIPIENTS: "recipients",
  JOURNEYS: "journeys",
  ADMIN: "admin",
};

const ACCESS_PROFILES = {
  [ACCESS.APP]: [PROFILES.ADMIN, PROFILES.READ],
  [ACCESS.CAMPAIGNS]: [PROFILES.ADMIN],
  [ACCESS.RECIPIENTS]: [PROFILES.ADMIN, PROFILES.READ],
  [ACCESS.JOURNEYS]: [PROFILES.ADMIN],
  [ACCESS.ADMIN]: [PROFILES.ADMIN],
};

export const getAllowedProfiles = (access) => ACCESS_PROFILES[access] ?? [];

export const hasAccess = (profileId, access) =>
  getAllowedProfiles(access).includes(Number(profileId));
